import { ToolbarConfig } from 'components-fabric/_types';
import { IRootieComponent } from '@components-common/types';
import { assocPath, has, prop, propOr } from 'ramda';
import { Toolbar } from '@components-common/toolbar';
import { ConfigElement } from '@components-fabric';
import { normalizePath } from '../../../packages/core/toolbox/objects';


export const mapToolbar = (obj: ConfigElement|ToolbarConfig, context:any) => {
  const result: any = {
    id: `tlb_${propOr("NOT_SET","id", obj)}`,
    cat: "toolbar",
    type: propOr("viewer","type",context),
    Component: propOr(Toolbar, "toolbarComponent", obj),
  }
  if(has("left",obj)) {
    result.left = obj.left;  // code added to override the default buttons of toolbar
    assocPath(normalizePath("props.left"), prop("left",obj), result);
  }

  if(has("right",obj)) {
    result.right = obj.right; // code added to override the default buttons of toolbar
    assocPath(normalizePath("props.right"), prop("right",obj), result);
  }
  return result;
}
